import type { ESubscriptionTier } from "@aix/vidmax-shared/src/constants/enums"
import type { EFeaturesVidmax } from "@aix/vidmax-shared/src/constants/pricing"
import { _checkUserFeatureAccess } from "@aix/vidmax-shared/src/constants/pricing"
import { createContext, useContext } from "react"

interface FreemiumModalContextProps {
  notEnoughCreditsErrorString: string
  setNotEnoughCreditsErrorString: (value: string) => void
  cardPastDueErrorString: string
  setCardPastDueErrorString: (value: string) => void
  requiredFeatureAccess?: {
    feature: EFeaturesVidmax
    requiredSubscriptionType: ESubscriptionTier
  }
  checkFeatureAccessAndShowUpgrade: (feature: EFeaturesVidmax) => boolean
  setUpgradeToProString: (value: string) => void
  upgradeToProString: string
}

export const FreemiumModalContext = createContext<FreemiumModalContextProps | null>(null)

export function useFreemiumModalContext() {
  const context = useContext(FreemiumModalContext)
  if (!context) {
    throw new Error("useFreemiumModal must be used within a FreemiumModalProvider")
  }
  return context
}
